const ChevronUp = ({ fill = '#000' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path fill={fill} d="M8 5l5 5-.7.7L8 6.4l-4.3 4.3L3 10l5-5z"></path>
    </svg>
  );
};

export default ChevronUp;
